//  Created by Juan Corona
//  Copyright (c) 2016 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.
//
//  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
//  ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
//  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
//  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
//  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
//  BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
//  DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
//  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
//  OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
//  OF THE POSSIBILITY OF SUCH DAMAGE.
define('readium_shared_js/models/metadata',[], function () {

    /**
     *  Wrapper of the Metadata object, created in openBook()
     *
     * @class  Models.Metadata
     */
    var Metadata = function(packageMetadata) {
        this.identifier = undefined;
        this.title = undefined;
        this.author = undefined;
        this.description = undefined;
        this.publisher = undefined;
        this.language = undefined;
        this.rights = undefined;
        this.modifiedDate = undefined;
        this.publishedDate = undefined;
        this.epubVersion = undefined;

        if (packageMetadata) {
            this.identifier = packageMetadata.id;
            this.title = packageMetadata.title;
            this.author = packageMetadata.author;
            this.description = packageMetadata.description;
            this.language = packageMetadata.language;
            this.publisher = packageMetadata.publisher;
            this.rights = packageMetadata.rights;
            this.modifiedDate = packageMetadata.modified_date;
            this.publishedDate = packageMetadata.pubdate;
            this.epubVersion = packageMetadata.epub_version;
        }
    };

    return Metadata;
});


